import React from 'react';
import { motion } from 'framer-motion'
import { useSelector } from 'react-redux'
import { useLocation, Link } from 'react-router-dom'
import { useWindowSize } from 'react-use'
import Footer from './Footer'

export default function AnimationLayout(props) {
  const location = useLocation()
  const gameState = useSelector(state => state.game)
  const studyGameState = useSelector(state => state.studyGame)
  const { width } = useWindowSize()

  const containerVariants = {
    hidden: {
      opacity: 0,
      position: 'absolute',
      width: '100%',
      transition: { ease: 'easeInOut' },
      display: 'none'
    },
    visible: {
      opacity: 1,
      y: 0,
      position: 'relative',
      width: '100%',
      transition: {
        delay: 0.5,
        duration: 0.5,
        ease: 'easeInOut'
      },
      display: 'block'
    },
    exit: {
      y: '-20px',
      opacity: 0,
      transition: {
        duration: 0.5,
        ease: 'easeInOut'
      },
      transitionEnd: { display: 'none' }
    }
  }

  return (
    <motion.div
      variants={containerVariants}
      initial='hidden'
      animate='visible'
      exit='exit'
    >
      {(width > 768 && location.pathname !== '/') &&
        <div className='flex justify-center w-100 pb-6'>
          {(gameState.narrative !== null || studyGameState.isGameOn) ?
            <img alt='Adventour Logo' src={require('../assets/logo/nav-logo.png')} />
            :
            <Link to='/'>
              <img alt='Adventour Logo' src={require('../assets/logo/nav-logo.png')} />
            </Link>
          }
        </div>
      }
      <div id='content-container'>
        {props.children}
      </div>
      <Footer />
    </motion.div>
  )
} 